/**
 * Formats a person name as Title Case while preserving spaces and hyphens.
 * e.g. "maría fernanda lópez" → "María Fernanda López"
 */
export const toTitleCase = (raw: string): string =>
  raw.replace(/[^\s-]+/g, (word) => {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
